export default "__VITE_ASSET__DbDI7WdJ__"